import { Globe } from "lucide-react";
import { useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { claveOrigen } from "../dominio/catalogos";

/**
 * Los leads que llegan por la web, con su etiqueta (Robert, 30/10/2026: «para diferenciarlos de los de
 * llamada en frío»). Solo «Web»; de qué formulario y página, al pasar el ratón.
 */
export const EtiquetaWeb = ({
  fuente,
  className,
}: {
  fuente?: string | null;
  className?: string;
}) => {
  const translate = useTranslate();
  return (
    <Badge
      variant="outline"
      className={cn(
        "border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-800 dark:bg-violet-950 dark:text-violet-300",
        className,
      )}
      title={
        fuente
          ? translate("nevora.negocios.web_ayuda", { fuente })
          : translate("nevora.negocios.web_ayuda_sin_fuente")
      }
      data-testid="etiqueta-web"
    >
      <Globe aria-hidden />
      {translate(claveOrigen("web"))}
    </Badge>
  );
};
